var map = {
	"./android.svg": 8503,
	"./angular.svg": 8732,
	"./azure.svg": 8979,
	"./css.svg": 1815,
	"./express.svg": 2142,
	"./firebase.svg": 493,
	"./flask.svg": 1231,
	"./github.svg": 8948,
	"./hibernate.svg": 7068,
	"./html.svg": 7985,
	"./ionic.svg": 968,
	"./java.svg": 9810,
	"./javascript.svg": 4831,
	"./jquery.svg": 1400,
	"./linux.svg": 6468,
	"./microservices.svg": 9266,
	"./microsoft-sql-server.svg": 1575,
	"./mongodb.svg": 576,
	"./mysql.svg": 5484,
	"./neo4j.svg": 8510,
	"./nodejs.svg": 8515,
	"./open-source.svg": 2676,
	"./opencv.svg": 7297,
	"./postgresql.svg": 4684,
	"./python.svg": 5560,
	"./react.svg": 6587,
	"./sass.svg": 3888,
	"./solidity.svg": 1333,
	"./spring.svg": 1465,
	"./sqlite.svg": 1506,
	"./tailwind-css.svg": 4620,
	"./typescript.svg": 5831,
	"./web3.svg": 5275
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 466;